export const Nav = ({ steps, currStageIdx }) => {

   return (
         <div className='nav-steps' >
            {
               steps.map((step, stepIdx) =>
                  <div key={stepIdx} className='step' style={{ left: `${25 * stepIdx}%` }}>
                     <h3 style={{ color: stepIdx === currStageIdx && 'black' }}>{step}</h3>
                  </div>
               )
            }
            <div style={{ left: `${(currStageIdx * 25)}%`, width: '25%' }}></div>
         </div>
   )
}
